import newRelic from 'src/utils/trackers/NewRelic';
import DeviceStorage from 'src/components/DeviceStorage/DeviceStorage';

function getTimestamp() {
  const fecha = new Date();
  return fecha.getTime();
}

function getStorageValue(key) {
  const value = DeviceStorage.getItem(key);

  return value || '';
}

function getErrorMessage(content, fallbackMessage) {
  if (fallbackMessage) {
    return fallbackMessage;
  }

  if (!content) {
    return '';
  }

  if (typeof content === 'string') {
    return content;
  }

  if (content.error_message) {
    return content.error_message;
  }

  if (content.message && typeof content.message === 'string') {
    return content.message;
  }

  if (content.message && content.message.stackTrace) {
    return content.message.stackTrace;
  }

  if (content.stackTrace) {
    return content.stackTrace;
  }

  return '';
}

function getErrorCode(content, fallbackCode) {
  if (fallbackCode) {
    return fallbackCode;
  }

  if (content && content.error_code) {
    return content.error_code;
  }

  return '';
}

class NewRelicTracker {

  getTrackerName() {
    return 'NewRelicTracker';
  }

  setup(pgm = {}, extraParams = {}, streamContentType = null) {
    const group = pgm.response && pgm.response.group ? pgm.response.group : {};
    const common = group.common || {};

    NewRelicTracker.groupId = common.id || '';
    NewRelicTracker.content_id = common.id || '';
    NewRelicTracker.content_name = common.title || '';
    NewRelicTracker.currentStreamContentType = streamContentType;
    NewRelicTracker.region = pgm.entry.region || '';
    NewRelicTracker.user_id = pgm.entry.user_id || '';
  }

  addPageAction(eventName, payload) {

    try {
      newRelic.recordCustomEvent(eventName, payload);
    } catch (error) {}
  }

  buildPayload(extra = {}) {
    return {
      ...extra,
      content_id: NewRelicTracker.content_id || '',
      content_name: NewRelicTracker.content_name || '',
      content_type: NewRelicTracker.currentStreamContentType || '',
      region: NewRelicTracker.region,
      user_id: NewRelicTracker.user_id,
      timestamp: getTimestamp()
    };
  }

  play() {
    this.addPageAction('content_play', this.buildPayload({eventType: 'content_play'}));
  }

  playing(currentTime) {
    this.addPageAction('content_play', this.buildPayload({eventType: 'content_play'}));
  }

  resume(currentTime) {
    this.addPageAction('content_play', this.buildPayload({eventType: 'content_play'}));
  }

  pause(currentTime) {
    this.addPageAction('content_pause', this.buildPayload({eventType: 'content_pause'}));
  }

  stop(currentTime, isLive, urlStop) {
    this.addPageAction('content_stop', this.buildPayload({eventType: 'content_stop'}));
  }

  error(content = {}, currentTime = 0, errorCode = '', errorMessage = '') {
    this.addPageAction('player_error', {
      eventType: 'player_error',
      error_message: getErrorMessage(content, errorMessage),
      error_code: getErrorCode(content, errorCode),
      content_id: content.content_id || NewRelicTracker.content_id || '',
      timestamp: getTimestamp(),
    });
  }

  apiError(content = {}, currentTime = 0, errorCode = '', errorMessage = '') {
    this.addPageAction('api_error', {
      eventType: 'api_error',
      error_message: getErrorMessage(content, errorMessage),
      error_code: getErrorCode(content, errorCode),
      url: content.url || '',
      timestamp: getTimestamp(),
    });
  }
}

NewRelicTracker.groupId = null;
NewRelicTracker.content_id = null;
NewRelicTracker.content_name = null;
NewRelicTracker.currentStreamContentType = null;

export default NewRelicTracker;



// WEBPACK FOOTER //
// ./src/utils/trackers/NewRelicTracker.js